// extracted by mini-css-extract-plugin
module.exports = {"grid":"Weekdays-module--grid--d4lfg","wrapper":"Weekdays-module--wrapper--3i6UM"};